module.exports = __webpack_public_path__ + "static/media/potters-1985519_1920.64b37058.jpg";